export const SystemMessageModalKey = "show-system-message-modal";
